import { absoluteBaseUrl } from '~/constants/environment';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useConfiguration } from '~/context/common/StaticContext';
import {
  useDealershipId,
  useIsDealershipPage
} from '~/context/dealership/StaticContext';
import {
  SoftPullLocations,
  useOpenSoftPullModal
} from '~/hooks/srp/useToggleSoftPullModal';
import buildDealershipUrl from '~/utilities/dealership/buildDealershipUrl';
import ConditionalTile from './ConditionalTile';

type OwnProps = {
  position: number;
};

export default function FinanceTile({ position }: OwnProps) {
  const { shouldUseTitleCasing } = useConfiguration();
  const trackEvent = useTrackEvent();
  const dealershipId = useDealershipId();
  const isDealership = useIsDealershipPage();
  const openSoftPullModal = useOpenSoftPullModal(SoftPullLocations.Conditional);

  return (
    <ConditionalTile
      anchorProps={{
        id: 'FinanceTile',
        href: isDealership
          ? buildDealershipUrl(
              `${absoluteBaseUrl}/financing`,
              dealershipId,
              'softpull'
            )
          : '#',
        onClick: ev => {
          trackEvent('Conditional Tile', {
            action: 'clicked',
            tile: 'FinanceTile',
            position
          });

          if (!isDealership) {
            ev.stopPropagation();
            ev.preventDefault();

            openSoftPullModal();
          }
        }
      }}
      ctaCopy={shouldUseTitleCasing ? 'Get Pre-Qualified' : 'Get pre-qualified'}
      description="Real, personalized financing terms in less than 2 minutes, with no hit to your credit."
      imageProps={{
        src: `${process.env.CVNA_APP_CDN_ASSETS_PATH}/images/heliosConditionalTiles/finance-illustration.png`,
        alt: 'Finance'
      }}
      position={position}
      tileName="FinanceTile"
      title="Finance with Carvana"
    />
  );
}
